import { gql } from "@apollo/client";

export const getTrendingTags = gql`
    query GetTrendingTags {
        trendingTags {
            id
            event
            location {
                name
                graphicUnicode
            }
            expiresAt
            tag
        }
    }
`;
